import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import graphicDesign from "../images/Graphic-Design.avif";
import { Helmet } from "react-helmet-async";

export default function Graphicsdesigningservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const designServices = [
    { icon: "fa-palette", title: "Business Logos & Branding", desc: "Memorable, timeless logos + complete brand identity kits (color palettes, typography, guidelines) that instantly communicate your brand personality." },
    { icon: "fa-box", title: "Print & Packaging Design", desc: "Eye-catching product packaging, labels, boxes, and print collateral that stand out on shelves and reinforce premium brand perception." },
    { icon: "fa-laptop-code", title: "Web & UI Graphics", desc: "High-performance website banners, icons, illustrations, favicons, and UI elements that perfectly align with your brand and enhance user experience." },
    { icon: "fa-id-card", title: "Business Cards & Flyers", desc: "Professional, premium-feel business cards, flyers, and promotional print materials designed to make strong first impressions." },
    { icon: "fa-book-open", title: "Brochures & Catalogs", desc: "Elegant, well-structured brochures, product catalogs, and lookbooks that showcase offerings clearly and persuasively." },
    { icon: "fa-bullhorn", title: "Marketing Collateral Graphics", desc: "Persuasive banners, social media graphics, email templates, ad creatives, and campaign visuals optimized for conversions." },
    { icon: "fa-chalkboard-teacher", title: "Multimedia Presentations", desc: "Stunning PowerPoint/Keynote/Google Slides decks with custom visuals, infographics, and animations for pitches, reports, and training." },
    { icon: "fa-sign-hanging", title: "Signage & POS Materials", desc: "Impactful store signage, banners, posters, window graphics, and point-of-sale displays that attract attention and drive in-store sales." },
  ];

  return (
    <div>
      <Helmet>
        <title>Professional Graphic Design Services - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/graphics-designing-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Graphic Designing Services
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>Brand Your Business With</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                Premium <span>Graphic Design Solutions</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              Great design doesn’t just look good — it communicates, connects emotionally, builds trust, and drives action. We transform your ideas into powerful visual stories through strategic, high-quality graphic design that strengthens your brand identity and stands out in competitive markets.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              From logos that become iconic to packaging that sells, web visuals that convert, and marketing materials that persuade — our creative team delivers affordable, fast-turnaround, and commercially effective designs tailored to your vision.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={graphicDesign}
              alt="Graphic Design Services"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* What We Offer - Design Services Cards */}
      <div className="container my-2 py-2" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>What We Design For Your Brand</h3>
        </div>
        <div className="row g-4">
          {designServices.map((item, i) => (
            <div className="col-lg-3 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Strategy / Closing Section */}
      <div
        className="container-fluid py-2"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h3 className="mb-4" style={{ fontWeight: 700 }}>
                Our Design Philosophy & Strategy
              </h3>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                We don’t just create pretty pictures — we solve business problems through visual communication. Every design reflects your brand’s personality, values, mission, and target audience while being commercially effective and versatile across print, digital, and physical touchpoints.
              </p>
              <p style={{ fontSize: "1.1rem", maxWidth: "900px", margin: "0 auto 2rem" }}>
                Using the latest tools (Adobe Creative Suite, Figma, Procreate, etc.), trend-aware aesthetics, and deep understanding of branding psychology — we deliver standout designs that help your business look professional, trustworthy, and premium.
              </p>

           <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Contact Now &rarr;
</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}